import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { cx } from './cx';
import { controlBase } from './Input';
import { useFieldControl } from './Field';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, id, children, ...rest },
  ref,
) {
  const field = useFieldControl(id);
  return (
    <select
      ref={ref}
      {...field}
      className={cx(
        controlBase,
        // The chevron is drawn rather than left to the platform so the control
        // matches the Icon set: 1.5 stroke, square caps.
        'appearance-none bg-[length:14px] bg-[right_0.75rem_center] bg-no-repeat pr-9',
        // The chevron is drawn from the ink token rather than a baked hex.
        // It used to be %235f6e66, a colour the palette retired, so in dark
        // it was a dark grey arrow on a dark control.
        "bg-[image:var(--ct-select-chevron)]",
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});
